import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useRemoveDeliveryManFromOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, data.currentStatusName);

  return useApiMutation({
    url: `/orders/${orderId}/delivery-men`,
    method: 'DELETE',
    errorTitle: 'Erro ao remover entregador',
    successTitle: 'Remover entregador do pedido',
    successMessage: 'Entregador removido com sucesso',
    onSuccess,
  });
};

export default useRemoveDeliveryManFromOrder;
